const scrollTo = (id, timeout, options) => {
    const t = timeout ? timeout : 0
    const o = options ? options : undefined
    setTimeout(() => {
        let elem = document.getElementById(id)
        if (elem) {
            elem.scrollIntoView(o)
        }
    }, t)
}

export default scrollTo